import React from 'react';

const VARIANT_STYLES = {
  default: { bg: '#FFFFFF', label: '#6B6B6B', value: '#1A1A1A', subtitle: '#6B6B6B' },
  success: { bg: '#FFFFFF', label: '#6B6B6B', value: '#2D7A4A', subtitle: '#6B6B6B' },
  danger:  { bg: '#FFFFFF', label: '#6B6B6B', value: '#C8442A', subtitle: '#6B6B6B' },
  dark:    { bg: '#1A1A1A', label: '#9A9A9A', value: '#FFFFFF', subtitle: '#D7D7D2' },
};

export default function KPICard({ label, value, subtitle, accent = 'default', progress }) {
  const variant = VARIANT_STYLES[accent] || VARIANT_STYLES.default;
  const isDark = accent === 'dark';

  return (
    <div style={{ ...styles.card, background: variant.bg }}>
      <div style={{ ...styles.label, color: variant.label }}>{label}</div>
      <div
        style={{
          ...styles.value,
          color: variant.value,
          fontSize: isDark ? 64 : 32,
          letterSpacing: isDark ? '-0.03em' : '-0.02em',
          lineHeight: isDark ? 1 : 1.1,
        }}
      >
        {value}
      </div>
      {subtitle && (
        <div style={{ ...styles.subtitle, color: variant.subtitle }}>{subtitle}</div>
      )}
      {isDark && typeof progress === 'number' && (
        <div style={styles.progressTrack} aria-hidden>
          <div
            style={{
              ...styles.progressFill,
              width: `${Math.max(0, Math.min(100, progress))}%`,
            }}
          />
        </div>
      )}
    </div>
  );
}

const styles = {
  card: {
    borderRadius: 16,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minHeight: 100,
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  value: {
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 13,
    fontWeight: 400,
  },
  progressTrack: {
    marginTop: 8,
    height: 4,
    width: '100%',
    background: 'rgba(255,255,255,0.12)',
    borderRadius: 999,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    background: '#E8502A',
    borderRadius: 999,
    transition: 'width 600ms ease',
  },
};
